import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'Was ist ein individueller Sanierungsfahrplan?',
    a: 'Ein individueller Sanierungsfahrplan (iSFP) ist ein standardisiertes Instrument, das den energetischen Ist-Zustand Ihres Gebäudes analysiert. Er zeigt auf, wie Sie Ihre Immobilie Schritt für Schritt oder in einem Zug energetisch sinnvoll modernisieren können. Zudem sichert er Ihnen einen zusätzlichen Förderbonus von 5 % bei der Umsetzung der Maßnahmen.'
  }, {
    q: 'Welche Förderungen gibt es?',
    a: 'Die wichtigsten Fördergeber sind das BAFA (Bundesamt für Wirtschaft und Ausfuhrkontrolle) für Einzelmaßnahmen wie Heizungstausch oder Dämmung und die KfW (Kreditanstalt für Wiederaufbau) für Komplettsanierungen zum Effizienzhaus. Die Förderungen bestehen meist aus direkten Investitionszuschüssen oder zinsgünstigen Krediten mit Tilgungszuschuss.'
  }, {
    q: 'Wann benötige ich eine Energieeffizienz-Expertin?',
    a: 'Eine zertifizierte Energieeffizienz-Expertin ist zwingend erforderlich, wenn Sie staatliche Fördermittel (BAFA/KfW) für energetische Sanierungen beantragen möchten. Auch beim Kauf einer Bestandsimmobilie oder bei hohen Energiekosten ist eine unabhängige Beratung sinnvoll, um Fehlinvestitionen zu vermeiden.'
  }, {
    q: 'Lohnt sich eine energetische Sanierung?',
    a: 'Ja, in den meisten Fällen. Neben der deutlichen Reduzierung der Energiekosten und CO2-Emissionen steigert eine Sanierung den Wert der Immobilie erheblich. Zudem verbessert sich der Wohnkomfort spürbar durch ein besseres Raumklima und den Wegfall von Zugluft oder kalten Wänden.'
  }, {
    q: 'Wie läuft eine Beratung ab?',
    a: 'Nach einem kostenlosen Erstgespräch folgt in der Regel ein Vor-Ort-Termin zur Datenaufnahme. Anschließend erstelle ich die Berechnungen und Konzepte (z.B. den iSFP). In einem Abschlussgespräch erläutere ich Ihnen die Ergebnisse verständlich und wir besprechen die nächsten Schritte sowie die Fördermittelbeantragung.'
  }, {
    q: 'Welche Gebäude werden betreut?',
    a: 'Mein Fokus liegt auf Wohngebäuden im Bestand – vom historischen Altbau über das Einfamilienhaus aus den 70er Jahren bis hin zum Mehrfamilienhaus. Durch meinen architektonischen Hintergrund betrachte ich dabei nicht nur die Technik, sondern auch die Bausubstanz und Ästhetik des Gebäudes.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 md:py-32 bg-secondary" data-id="element-166">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-167">
        <div className="text-center mb-16" data-id="element-168">
          <h2 className="text-4xl md:text-5xl font-serif text-accent mb-6" data-id="element-169">
            Häufige Fragen
          </h2>
        </div>

        <div className="space-y-4" data-id="element-170">
          {faqs.map((faq, index) => <div key={index} className="border border-accent/10 rounded-xl bg-white overflow-hidden" data-id="element-171">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-6 flex justify-between items-center text-left hover:bg-accent/[0.02] transition-colors" data-id="element-172">
                <span className="font-serif text-xl text-accent pr-8" data-id="element-173">
                  {faq.q}
                </span>
                <span className="text-primary shrink-0" data-id="element-174">
                  {openIndex === index ? <MinusIcon size={20} data-id="element-175" /> : <PlusIcon size={20} data-id="element-176" />}
                </span>
              </button>

              <AnimatePresence data-id="element-177">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-178">
                    <div className="px-6 pb-6 text-accent/70 font-light leading-relaxed" data-id="element-179">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}